import { Fire, Handshake } from '@phosphor-icons/react';
import { Partnerships } from "./Partnerships";

import { HookObject, ListItemsHooks } from "@/plugins/types";
import { Dashboard } from "./Dashboard";

export const onListItems = (hook: HookObject, _, __, { permissions = [] }) => {
  if (hook.id === ListItemsHooks.APP_DRAWER && hook.position === "top") {
    if (!permissions.includes("partnerships")) return [];
    return [
      {
        label: "Partnerships",
        icon: <Handshake className="text-lg" />,
        href: "/partnerships",
      },
    ];
  }

  if (hook.id === ListItemsHooks.ROUTES) {
    if (!permissions.includes("partnerships")) return [];
    return [
      {
        path: "/partnerships",
        element: <Partnerships name="Partnership Programs" />,
        children: [
          {
            path: ":id",
            element: <Dashboard name="Partnership Programs" />,
          },
        ],
      },
    ];
  }
};


export { Partnerships };